const defaultSortModel = {
    field: 'Company_Name',
    sort: 'asc'
};
const defaultPagination = {
    page: 0,
    pageSize: 25,
    sort: [defaultSortModel],
    cache: true
};
export { defaultPagination };
